import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { BannerSearchRequest } from '../api/banner/bannersearch/bannersearchrequest';
import { BannerSearchResponse, BannerSearchResponseDtoImpl } from '../api/banner/bannersearch/bannersearchresponse';
import { BannerSearchBuilder } from '../dto/bannersearch/bannersearchbuilder';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';

export class BannerSearchAPIProcessorImpl extends APIProcessorImpl<BannerSearchRequest, BannerSearchResponse>
{
    private LOGGER: Logger = LogManager.getLogger(BannerSearchAPIProcessorImpl.name);
    execute(request: BannerSearchRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void {
        this.LOGGER.log("onSuccess() invoked");
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new BannerSearchResponseDtoImpl(APIFeatures.BANNER_SEARCH, "Banner Search Success");
                let bannerSearchResponse = new BannerSearchBuilder(responseMapper.getResponseMap(), this.getContext()).buildAll();

                response.setBannerSearchDto(bannerSearchResponse);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new BannerSearchResponseDtoImpl(APIFeatures.BANNER_SEARCH, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new BannerSearchResponseDtoImpl(APIFeatures.BANNER_SEARCH, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new BannerSearchResponseDtoImpl(APIFeatures.BANNER_SEARCH, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
    
            this.getAPIFailure(new BannerSearchResponseDtoImpl(APIFeatures.BANNER_SEARCH, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/bannersearchapiprocessor.tsx